import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { Subcategoria } from '@app/models/subcategoria.model';
import { SubcategoriaService } from '@app/services/subcategoria.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subcategorias-list',
  templateUrl: './subcategorias-list.component.html',
  styleUrls: ['./subcategorias-list.component.scss']
})
export class SubcategoriasListComponent implements OnInit {

  lstSubcategoria: Subcategoria[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private subcategoriaService: SubcategoriaService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.subcategoriaService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstSubcategoria = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(subcategoria: Subcategoria) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o documento: " + subcategoria.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.subcategoriaService.deletar(subcategoria.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      }, erro => {
        for(let er of erro.error.errors) {
          this.toastr.warning(er);
        }
    });
  }
}

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
